// extracted by mini-css-extract-plugin
export default {"Header":"HeaderSection_Header__h+t5X","Header__right":"HeaderSection_Header__right__HJQBB","Header__descriptionItem":"HeaderSection_Header__descriptionItem__VWJlR"};